import React, { useState } from 'react';
import { createBrowserRouter, createRoutesFromElements, Navigate, Route, RouterProvider } from 'react-router-dom';
import { PageLayout } from '../PageLayout';
import PageRender from '../PageRender/index.js';
import Dashboard from '../../Pages/Dashboard/index.js';
import WorkbookList from '../../views/Workbook/workbook-list.component.js';
import WorkbookListV2 from '../../views/Workbook/workbook-list-v2.component.jsx';
import CreateWorkbook from '../../views/Workbook/create-workbook.component.js';
import EditWorkbook from '../../views/Workbook/edit-workbook.component.js';
import useAuth from '../../Hooks/useAuth.js';
import Loading from '../Loading/index.js';
import RouteTracker from '../Analytics/RouteTracker.jsx';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import ErrorPage from '../../Pages/Error/index.js';
import Book from '../../Pages/User/library/[id]';
import BookV2 from '../../Pages/User/libraryV2/[id]';
import { layoutLoader } from '../../Helpers/Functions';
import { WorkbookEditorV2 } from '../WorkbookV2/WorkbookEditorV2';
import ToolsV2Layout from '../../Pages/Admin/toolsv2/ToolsV2Layout.js';
import ToolsV2 from '../../Pages/Admin/toolsv2/index.js';
import CreateTool from '../../Pages/Admin/toolsv2/create.js';
import EditTool from '../../Pages/Admin/toolsv2/[id].js';

const publicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;

const stripePromise = loadStripe(publicKey);

const ProtectedRoutes = () => {
  const { isLoading, userData } = useAuth();

  const [openSection, setOpenSection] = useState(localStorage.getItem('openCategory'));

  const options = {
    mode: 'setup',
    currency: 'usd',
    paymentMethodCreation: 'manual'
  };

  if (isLoading) {
    return <Loading />;
  }

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route element={<RouteTracker />}>
        <Route path="/library/v2/:id" element={<BookV2 />} errorElement={<ErrorPage />} id="libraryV2"></Route>
        <Route path="/library/:id" element={<Book />} errorElement={<ErrorPage />} id="library"></Route>
        <Route path="/" element={<PageLayout />} loader={layoutLoader} errorElement={<ErrorPage />} id="root">
          <Route index element={<Dashboard />} id="dashboard" />
          <Route path="/:page" element={<PageRender />} id="pageRender" />
          <Route path="/:page/:id" element={<PageRender />} id="pageRenderWithId" />
          <Route path="/:page/:id/view" element={<PageRender />} id="pageRenderView" />
          {userData?.role === 'admin' && (
            <>
              <Route path="workbook" element={<WorkbookList />} id="workbookList" />
              <Route path="workbook/v2" element={<WorkbookListV2 />} id="workbookListV2" />
              <Route path="workbook/create-workbook" element={<CreateWorkbook />} id="createWorkbook" />
              <Route path="workbook/workbook-list" element={<WorkbookList />} id="workbookListAgain" />
              <Route
                path="workbook/:id"
                element={<EditWorkbook activeCat={openSection} setActiveCat={setOpenSection} />}
                id="editWorkbook"
              />
              <Route path="workbook/v2/:id" element={<WorkbookEditorV2 />} id="editWorkbookV2" />
              <Route path="tools/v2" element={<ToolsV2Layout />} id="toolsV2Layout">
                <Route index element={<ToolsV2 />} id="toolsV2List" />
                <Route path="create" element={<CreateTool />} id="createTool" />
                <Route path=":id" element={<EditTool />} id="editTool" />
              </Route>
            </>
          )}

          <Route path="*" element={<Navigate to="/" />} id="navigateRoot" />
          <Route path="/signup" element={<Navigate to="/" />} id="navigateSignup" />
        </Route>
      </Route>
    )
  );

  return (
    <Elements stripe={stripePromise} options={options}>
      <RouterProvider router={router} />
    </Elements>
  );
};

export default ProtectedRoutes;
